import { callGetApi, callPostApi, callPutApi } from "api/ApiCaller";
import {
  Edit_Brand_List_Item_PUT,
  Get_Brand_List_Item_GET,
  Save_Brand_List_Item_POST,
} from "api/ApiConst";
import { API_SUCCESS } from "api/ResponseCodes";
import ModalWrapper from "components/common/ModalWrapper";

import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { MODAL_LOADER } from "utils/constants";
import { isEmpty } from "utils/TextUtils";

const BrandAddEdit = ({ show, hideModal, recordID, handleRefresh }) => {
  const [record, setRecord] = useState({
    title: "",
  });

  const checkInputValidation = () => {
    if (isEmpty(record.title)) {
      toast.error("Title must not be empty.", {
        id: "restaurantTitle",
      });
      return;
    }
    return true;
  };

  const handleSubmit = () => {
    try {
      if (!checkInputValidation()) {
        return;
      }
      if (recordID) {
        // update
        callPutApi(
          MODAL_LOADER,
          Edit_Brand_List_Item_PUT.replace("{uuid}", recordID),
          record,
          {},
          (res) => {
            if (res.errorCode === API_SUCCESS) {
              hideModal(false);
              handleRefresh();
            }
          }
        );
      } else {
        // Create
        callPostApi(
          MODAL_LOADER,
          Save_Brand_List_Item_POST,
          record,
          {},
          (res) => {
            if (res.errorCode === API_SUCCESS) {
              hideModal(false);
              handleRefresh();
            }
          },
          (error) => {
            console.log(error);
          }
        );
      }
    } catch (error) {
      return;
    }
  };

  useEffect(() => {
    recordID &&
      callGetApi(
        MODAL_LOADER,
        Get_Brand_List_Item_GET.replace("{uuid}", recordID),
        {},
        (res) => {
          setRecord({
            title: res.responsePacket.title,
          });
        }
      );
  }, [recordID]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRecord({ ...record, [name]: value });
  };
  return (
    <>
      <ModalWrapper
        show={show}
        hide={hideModal}
        header={`${recordID ? "Update" : "Add"}`}
        handleSubmit={handleSubmit}
      >
        <div className="container">
          <div className="row">
            <div className="mb-3">
              <label htmlFor="" className="form-label">
                Brand Name
              </label>
              <input
                type="text"
                className="form-control"
                value={record?.title}
                name="title"
                onChange={(e) => handleInputChange(e)}
              ></input>
            </div>
          </div>
        </div>
      </ModalWrapper>
    </>
  );
};

export default BrandAddEdit;
